export default {
    'ERROR-REGISTER-PROSPECT-EMAIL': {
        'USER-ALREADY-HELPER': {
            actionType: 'redirect',
            message: {
                fr: 'Vous avez déjà un compte, veuillez vous connecter.',
                en: 'You already have an account, please log in.',
            },
            redirectPath: '/login',
        },
        'PROSPECT-ALREADY-MATCHED': {
            actionType: 'redirect',
            message: {
                fr: 'Vous avez déjà un compte, veuillez vous connecter.',
                en: 'You already have an account, please log in.',
            },
            redirectPath: '/login',
        },
        'PROSPECT-WAITING-TO-BE-MATCHED': {
            actionType: 'redirect',
            redirectPath: '/helpee-waiting',
        },
        'PROSPECT-WAITING-STEP-2': {
            actionType: 'redirect',
            redirectPath: '/helpee-finish',
        },
    },
    'ERROR-ADD-MAIN-INFO': {
        'ANSWER-KEY-OR-KEYS-REQUIRED': {
            actionType: 'toast',
            message: {
                fr: 'Une réponse ou une liste de réponses est requise.',
                en: 'An answer or a list of answers is required.',
            },
        },
        'PROSPECT-ALREADY-HELPER': {
            actionType: 'redirect',
            message: {
                fr: 'Vous avez déjà un compte, veuillez vous connecter.',
                en: 'You already have an account, please log in.',
            },
            redirectPath: '/login',
        },
        'INVALID-PHONE-NUMBER': {
            actionType: 'toast',
            message: {
                fr: 'Numéro de téléphone invalide.',
                en: 'Invalid phone number.',
            },
        },
    },
    'ERROR-SEND-CODE': {
        'ERROR-INVALID-PHONE-NUMBER': {
            actionType: 'toast',
            message: {
                fr: 'Numéro de téléphone invalide.',
                en: 'Invalid phone number.',
            },
        },
        'ERROR-WHILE-SENDING-CODE': {
            actionType: 'toast',
            message: {
                fr: 'Erreur lors de l\'envoi du code.',
                en: 'Error while sending the code.',
            },
        },
    },
    'ERROR-VERIFY-CODE': {
        'CODE-REQUIRED': {
            actionType: 'toast',
            message: {
                fr: 'Le code est requis.',
                en: 'The code is required.',
            },
        },
        'INVALID-CODE': {
            actionType: 'toast',
            message: {
                fr: 'Le code est invalide.',
                en: 'The code is invalid.',
            },
        },
    },
    'ERROR-VERIFY-CODE-REFERRED': {
        'CODE-REQUIRED': {
            actionType: 'toast',
            message: {
                fr: 'Le code est requis.',
                en: 'The code is required.',
            },
        },
        'INVALID-CODE': {
            actionType: 'toast',
            message: {
                fr: 'Le code est invalide.',
                en: 'The code is invalid.',
            },
        },
    },
    'ERROR-GET-REFERRED-DATA': {
        'MISSING-REQUIREMENTS': {
            actionType: 'toast',
            message: {
                fr: "Les informations nécessaires sont manquantes",
                en: 'Missing required information',
            },
        },
        'TOO-MANY-REQUIREMENTS': {
            actionType: 'toast',
            message: {
                fr: "Trop d'informations fournies",
                en: 'Too many requirements',
            },
        },
        'REFERRAL-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Référence introuvable.",
                en: 'Referral not found.',
            },
            redirectPath: '/referral',
        },
        'REFERRAL-STATUS-INVALID': {
            actionType: 'redirect',
            message: {
                fr: "Le statut de la référence n'est pas valide pour l'inscription.",
                en: 'The referral status is not valid for sign-up.',
            },
            redirectPath: '/referral',
        },
        'AMBASSADOR-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Ambassadeur introuvable.",
                en: 'Ambassador not found.',
            },
            redirectPath: '/ambassador-not-found',
        },
        'REFERRAL-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne de référence introuvable.",
                en: 'Referral campaign not found.',
            },
            redirectPath: '/referral',
        },
    },
    'ERROR-POST-REFERRED': {
        'MISSING-REFERRAL-ID': {
            actionType: 'toast',
            message: {
                fr: "Un identifiant de référence est requis.",
                en: 'A referral ID is required.',
            },
        },
        'INVALID-REFERRAL-ID': {
            actionType: 'toast',
            message: {
                fr: "L'identifiant de référence est invalide",
                en: 'Invalid referral ID',
            },
        },
        'MISSING-REFERRAL-CAMPAIGN-ID': {
            actionType: 'toast',
            message: {
                fr: "L'UUID de la campagne de référence est requis pour un ID ambassadeur.",
                en: 'The referral campaign UUID is required for an ambassador ID.',
            },
        },
        'INVALID-EMAIL': {
            actionType: 'toast',
            message: {
                fr: "L'adresse e-mail fournie est invalide.",
                en: 'The provided email address is invalid.',
            },
        },
        'INVALID-PHONE-NUMBER': {
            actionType: 'toast',
            message: {
                fr: "Le numéro de téléphone fourni est invalide.",
                en: 'The provided phone number is invalid.',
            },
        },
        'AMBASSADOR-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Ambassadeur introuvable.",
                en: 'Ambassador not found.',
            },
            redirectPath: '/referral',
        },
        'REFERRAL-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne de référence introuvable.",
                en: 'Referral campaign not found.',
            },
            redirectPath: '/referral',
        },
        'REFERRED-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Référence introuvable.",
                en: 'Referred person not found.',
            },
            redirectPath: '/referral',
        },
    },
};
